import React from 'react';
import { Container } from './Loader.styled';

export default function Loader({ size, color, speed }) {
	return (
		<Container size={size} color={color} speed={speed}>
			<span />
			<span />
			<span />
		</Container>
	);
}
